import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from 'components/mui';
import { AddressType } from 'containers/pages/addressManagement/types';

interface AddressTypeSelectorProps {
  value: number | null;
  addressTypes: AddressType[];
  onChange: (event: unknown, newValue: AddressType | null) => void;
  error?: boolean;
  helperText?: string;
}

function AddressTypeSelector({
  value,
  addressTypes,
  onChange,
  error = false,
  helperText = '',
}: AddressTypeSelectorProps) {
  const selectedOption = addressTypes.find((t) => t.Id === value) || null;

  return (
    <Autocomplete
      value={selectedOption}
      options={addressTypes}
      getOptionLabel={(option) => option.Title || ''}
      isOptionEqualToValue={(option, val) => option.Id === val.Id}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Address Type"
          required
          error={error}
          helperText={helperText}
          size="small"
        />
      )}
      size="small"
      fullWidth
    />
  );
}

export default AddressTypeSelector;
